<template>
  <div class="menu-wrapper">
    <router-link v-if="!item.kindOne" :to="item.path">
      <el-menu-item :index="item.path" >
        <i class="menu-icon fa" :class="item.icon" aria-hidden="true"></i>
        <span class="navTitle" slot="title">{{ item.title }}</span>
      </el-menu-item>
    </router-link>
    <el-submenu :index="item.key" v-else="item.kindOne">
      <template slot="title">
        <i class="menu-icon fa" :class="item.icon" aria-hidden="true"></i>
        <span class="navTitle">{{ item.title }}</span>
      </template>
      <div v-for="(itemValue,indexValue) in item.kindOne" :key="indexValue">
        <router-link :to="itemValue.path" v-if="!itemValue.kindTwo">
          <el-menu-item :index="itemValue.path" >
            <i class="menu-icon fa" :class="itemValue.icon" aria-hidden="true"></i>
            <span class="navTitleTwo">{{ itemValue.title }}</span>
          </el-menu-item>
        </router-link>
        <el-submenu :index="itemValue.key" v-else="itemValue.kindTwo">
          <template slot="title">
            <i class="menu-icon fa" :class="itemValue.icon" aria-hidden="true"></i>
            <span class="navTitle">{{ itemValue.title }}</span>
          </template>
          <div v-for="(itemValueTwo,indexValueTwo) in itemValue.kindTwo" :key="indexValueTwo">
            <router-link :to="itemValueTwo.path">
              <el-menu-item :index="itemValueTwo.path" >
                <span class="navTitleTwo">{{ itemValueTwo.title }}</span>
              </el-menu-item>
            </router-link>
            
          </div>
        </el-submenu>
      </div>
    </el-submenu>
  </div>
</template>

<script>

export default {
  name: 'SidebarItem',
  props: {
    item: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.menu-wrapper {
  min-width: 180px;
  .menu-icon {
    margin-right: 10px;
    margin-left: -10px;
    color: #000000;
  }
  .el-menu-item {
    min-width:180px;
  }
  .navTitle {
    display: inline-block;
    min-width:88px;
    text-align:left;
  }
  .navTitleTwo {
    display: inline-block;
    min-width:88px;
    text-align:left;
  }
  a {
    display: inline-block;
    width: 100%;
    overflow: hidden;
    text-decoration: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue